/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const LoaderBox = styled.div`
  margin: 50px 0;
`;

export const Table = styled.div`
  width: 100%;
  border: 1px solid ${Palette.PrimaryGray._200};
`;

export const TableHead = styled.div`
  position: sticky;
  top: 77px;
  left: 0;
  display: grid;
  grid-template-columns: 145px 1fr 93px 125px 125px 115px 115px;
  padding: 16px 12px;
  font-size: 12px;
  line-height: 16px;
  background-color: ${Palette.PrimaryGray._000};
  color: ${Palette.PrimaryGray._500};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 145px 1fr 93px 125px 125px 115px 115px;
  padding: 16px 12px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  &:last-of-type {
    border-bottom: unset;
  }
`;

export const TableFooter = styled.div`
  display: flex;
  height: 56px;
  padding: 12px 0;
  color: ${Palette.PrimaryGray._500};
  background-color: ${Palette.PrimaryGray._000};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: unset;
`;

export const FooterBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-right: 6px;
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  border-radius: 4px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'auto')};
  pointer-events: ${({ isActive }) => (isActive ? 'auto' : 'none')};

  &:hover {
    color: ${Palette.PrimaryGray._700};
    background-color: ${Palette.Primary._000};
  }
`;

export const FooterBody = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 10px;
  border-left: 1px solid ${Palette.PrimaryGray._200};

  span {
    color: ${Palette.PrimaryGray._700};
  }
`;

export const ProgressBar = styled.div`
  position: relative;
  width: 64px;
  height: 4px;
  border-radius: 4px;
  background-color: ${Palette.PrimaryGray._200};
  overflow: hidden;

  ::before {
    content: ' ';
    position: absolute;
    height: 100%;
    width: ${({ status }) => `${status}%`};
    background-color: ${Palette.Primary._300};
  }
`;

export const NoDataWrap = styled.div`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  overflow: hidden;
  width: calc(100% - 4px);
  display: block;
  text-overflow: ellipsis;
  color: ${({ color }) =>
    color === 'red'
      ? `${Palette.Rose._600}`
      : color === 'green'
      ? `${Palette.Teal._600}`
      : `${Palette.PrimaryGray._700}`};
`;

export const TextBolder = styled(Text)`
  font-weight: 500;
`;
